/* global ajaxPath */
import listingFilters from './listing-filter.js';
// import { debounce } from './utils.js';
import $ from 'jquery';

const loadMore = {
  // Default sending state is set to False.
  sending: false,
  // Set up variable to hold number of posts.
  totalItems: 0,
  currentPage: 1,

  // Initialize the function.
  init: () => {
    const debounce = (func, wait = 20, immediate = true) => {
      let timeout;
      return function () {
        const context = this,
          args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    };

    // Get total number of items from Dataset.
    const listingWrapper = document.querySelector('.listing-wrapper');
    if (listingWrapper) {
      loadMore.totalItems = listingWrapper.dataset.totalitems;
      // Attach scroll event listener.
      document.addEventListener('scroll', debounce(loadMore.handleScroll));
    }
  },

  handleScroll: () => {
    const listingContainer = document.querySelector('.listing-container');
    const listingWrapper = listingContainer.querySelector('.listing-wrapper');

    // Get distance to bottom of container element
    const elementBottom = listingContainer.offsetTop + listingContainer.offsetHeight;

    // Get distance user has scrolled
    const scrollDistance = window.scrollY + window.innerHeight;

    // Send ajax call if:
    // User scrolls to bottom of container element &
    // a request is not currently being sent &
    // there are still more items to load.
    loadMore.currentPage = parseInt(listingWrapper.dataset.currentpage);
    if (
      scrollDistance > elementBottom &&
      !loadMore.sending &&
      loadMore.currentPage * 3 <= loadMore.totalItems
    ) {
      loadMore.ajaxCall(listingContainer, listingWrapper);
    }
  },

  ajaxCall: (listingContainer, listingWrapper) => {
    // Get post type from dataset
    const postType = listingContainer.dataset.posttype;
    const featuredPost = document.querySelector('.featured-image').dataset.featured;
    let currentPage = parseInt(listingWrapper.dataset.currentpage);

    // Set data for AJAX call
    const callData = {
      action: 'loadMore',
      post_type: postType,
      offset: 3 * currentPage,
      featured_post: featuredPost,
      post_per_page: 3,
    };

    $.ajax({
      url: ajaxPath.admin_path,
      data: callData,
      type: 'POST',
      beforeSend() {
        currentPage += 1;

        // Insert loading spinner as visual indication to user.
        listingContainer.insertAdjacentHTML(
          'beforeend',
          `
            <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
            </div>
            `
        );

        // Set sending state to true.
        loadMore.sending = true;
      },
      success(response) {
        // Insert query response at bottom of container element.
        listingWrapper.insertAdjacentHTML('beforeend', response);
        const listingElementList = document.querySelectorAll('.listing-container .news-item');
        listingElementList.forEach((listingElement) => {
          const newElements = [];
          if (!listingFilters.listingElementList.includes(listingElement)) {
            newElements.push(listingElement);
            listingFilters.updateDisplayedItems(newElements);
            newElements.forEach((element) => {
              listingFilters.listingElementList.push(element);
            });
          }
        });

        // When response is returned, set sending state to false.
        // Get and remove loading spinner when response is received.
        const spinner = listingContainer.querySelector('.spinner');
        setTimeout(() => {
          listingContainer.removeChild(spinner);
          loadMore.sending = false;
        }, 650);

        // Increase page count to represent current page of items.
        listingWrapper.dataset.currentpage = currentPage;
        loadMore.currentPage = currentPage;
      },
    });
  },
};

export default loadMore;
